import { __spreadArray } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import { useRef, useEffect, useCallback } from 'react';

function useEvent(callback) {
  var ref = useRef(callback);
  useEffect(function () {
    ref.current = callback;
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([ref], args, false));
  }, []);
}

export { useEvent as default };
